<template>
  <div class="toast-wrapper">
    <ToastNotification
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      :duration="toast.duration"
      :dismissible="toast.dismissible"
      @close="removeToast(toast.id)"
    />
  </div>
</template>

<script setup>
import { useToast } from '../composables/useToast';
import ToastNotification from './ToastNotification.vue';

const { toasts, removeToast } = useToast();
</script>

<style scoped>
.toast-wrapper {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  pointer-events: none;
}

.toast-wrapper > * {
  pointer-events: all;
}

@media (max-width: 768px) {
  .toast-wrapper {
    top: 10px;
    right: 10px;
    left: 10px;
  }
}
</style>
